import { fieldSchemaDefV1 } from '../../../common/fieldSchemaDef';
import { trpc } from '../../lib/trpc';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  Anchor,
  Button,
  Flex,
  Space,
  Switch,
  TextInput,
  Title,
} from '@mantine/core';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ulid } from 'ulid';
import { type z } from 'zod';

const fieldSchema = fieldSchemaDefV1.shape.fields.element;

export const FieldWizard = ({
  field,
  onSubmit,
}: {
  readonly field?: z.infer<typeof fieldSchema>;
  readonly onSubmit: (value: z.infer<typeof fieldSchema>) => void;
}) => {
  const { data: components } = trpc.components.list.useQuery();
  const { control, formState, handleSubmit, register, setValue } = useForm<
    z.infer<typeof fieldSchema>
  >({
    defaultValues: field || {
      id: ulid(),
      name: '',
      required: false,
      type: 'text',
    },
    resolver: zodResolver(fieldSchema),
  });
  const [step, setStep] = useState<'attributes' | 'type'>(
    field ? 'attributes' : 'type',
  );

  const submitHandler = handleSubmit((data) => {
    onSubmit(data);
  });

  if (step === 'type') {
    return (
      <Flex
        direction="column"
        gap="sm"
      >
        <Flex gap="sm">
          <Button
            onClick={() => {
              setValue('type', 'text');
              setStep('attributes');
            }}
          >
            Text
          </Button>
          <Button
            onClick={() => {
              setValue('type', 'rich');
              setStep('attributes');
            }}
          >
            Rich
          </Button>
        </Flex>
        {components && components.length > 0 && (
          <>
            <Title order={6}>Components</Title>
            <Flex gap="sm">
              {components.map((component) => (
                <Button
                  key={component.id}
                  onClick={() => {
                    setValue('type', 'component');
                    setValue('componentId', component.id);
                    setStep('attributes');
                  }}
                >
                  {component.name}
                </Button>
              ))}
            </Flex>
          </>
        )}
      </Flex>
    );
  }

  if (step === 'attributes') {
    return (
      <>
        <TextInput
          {...register('name')}
          error={formState.errors.name?.message}
          label="Name"
        />
        <Space h="lg" />
        <Controller
          control={control}
          name="required"
          render={({ field: { value, ...rest } }) => (
            <Switch
              label="Required field"
              {...rest}
              checked={value}
            />
          )}
        />
        <Space h="lg" />
        <Flex justify="space-between">
          <Button onClick={submitHandler}>Submit</Button>
          {field ? null : <Anchor onClick={() => setStep('type')}>Back</Anchor>}
        </Flex>
      </>
    );
  }

  return null;
};
